import { LicenseManager } from 'ag-grid-enterprise';

import('./bootstrap').catch(err => console.error(err));
LicenseManager.setLicenseKey('CompanyName=ITG,LicensedGroup=ITG1,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-027778,ExpiryDate=3_May_2023_[v2]_MTY4MzA2ODQwMDAwMA==24b98e293be9ae48f0d7f0925989e38e');
